// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pg-c";
export var backButton = "_pg-4";
export var backIcon = "_pg-5";
export var chevronShortcut = "_pg-6";
export var container = "_pg-1";
export var editor = "_pg-8";
export var editorWrapper = "_pg-7";
export var prefix = "_pg-2";
export var searchIcon = "_pg-3";
export var suffix = "_pg-9";
export var suffixContent = "_pg-a";
export var suffixText = "_pg-b";
export var wrapper = "_pg-0";